import { css } from "@emotion/react";
import Skeleton from "@mui/material/Skeleton";

import { colors } from "@dotnet/telematics-design-system";

const PaginationLoader = ({ ...props }) => {
    const { gray100 } = colors;

    const loaderWidths = [
        { id: 1, width: 36 },
        { id: 2, width: 36 },
        { id: 3, width: 51 },
        { id: 4, width: 36 },
        { id: 5, width: 36 }
    ];

    return (
        <div
            {...props}
            css={css({
                display: "flex",
                alignItems: "center",

                span: {
                    height: "36px",
                    borderRadius: "6px",
                    background: gray100
                },

                "& > span + span": {
                    marginLeft: "8px"
                }
            })}
        >
            {loaderWidths.map(({ id, width }) => (
                <Skeleton
                    key={id}
                    variant="rectangular"
                    width={width}
                    height={id === 3 ? "20px" : "36px"}
                />
            ))}
        </div>
    );
};

export default PaginationLoader;
